import { TraceCategory, TraceLevel } from '../../../types/unwind-debug.types';

export const LEVEL_COLOR: Record<TraceLevel, string> = {
  debug: '#9aa0a6',
  info: '#1e88e5',
  warn: '#f9a825',
  error: '#e53935',
};

export const CATEGORY_COLOR: Record<TraceCategory, string> = {
  orderbook: '#00897b',
  evaluation: '#3949ab',
  simulation: '#8e24aa',
  order: '#43a047',
  fill: '#7cb342',
  rule: '#5e35b1',
  recovery: '#00acc1',
  skip: '#757575',
  error: '#e53935',
  heartbeat: '#9e9e9e',
};
